<p>Add the details of your attornies below. Please ensure that you have their permission to record their information here.</p>
<hr />
<app-master-form [object]="object" [key]="key" [extraData]="extraData"></app-master-form >
